import { type Dispatch, type SetStateAction, useEffect, useState } from 'react';

export const useAbortController = (
  init = new AbortController()
): [AbortController, Dispatch<SetStateAction<AbortController>>] => {
  const [controller, setController] = useState(init);
  useEffect(() => () => controller.abort(), [controller]);
  return [controller, setController];
};
